"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _NestedClose = require("./comps/NestedClose");
var _NestedOpen = require("./comps/NestedOpen");
var _KeyValues = require("./comps/KeyValues");
var _ShowTools = require("./store/ShowTools");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "children", "parentValue", "keyid", "level", "value", "initialValue", "keyName"];
var Container = exports.Container = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    children = props.children,
    parentValue = props.parentValue,
    keyid = props.keyid,
    _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    value = props.value,
    initialValue = props.initialValue,
    keyName = props.keyName,
    elmProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var dispatch = (0, _ShowTools.useShowToolsDispatch)();
  var subkeyid = (0, _react.useId)();
  var defaultClassNames = [className, 'w-rjv-inner'].filter(Boolean).join(' ');
  var reset = {
    onMouseEnter: function onMouseEnter() {
      return dispatch((0, _defineProperty2["default"])({}, subkeyid, true));
    },
    onMouseLeave: function onMouseLeave() {
      return dispatch((0, _defineProperty2["default"])({}, subkeyid, false));
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    className: defaultClassNames,
    ref: ref
  }, elmProps), reset), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_NestedOpen.NestedOpen, {
      expandKey: subkeyid,
      value: value,
      level: level,
      keyName: keyName,
      initialValue: initialValue
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_KeyValues.KeyValues, {
      expandKey: subkeyid,
      value: value,
      level: level
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NestedClose.NestedClose, {
      expandKey: subkeyid,
      value: value,
      level: level
    })]
  }));
});
Container.displayName = 'JVR.Container';